import { render, staticRenderFns } from "./KorzinkaGoIcon.vue?vue&type=template&id=69a3c9a9"
import script from "./KorzinkaGoIcon.vue?vue&type=script&lang=js"
export * from "./KorzinkaGoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports